<div class="wrapper">
  <div class="row">
    <div class="col filter">
      <app-anlage-group-select [selectedItem]="uiState.anlageGroup"
      (selectedItemChange)="OnAnlageGroupSelected($event)"></app-anlage-group-select>
    </div>
  </div>
  <div #taskGrid class="task-grid">
    @if (!uiState.anlageGroup) {
      <div>
        <span class="info" i18n='Zuerst eine Anlagengruppe auswählen@@ChooseFacilityGroupFirst'>First choose a facility
        group. ...</span>
      </div>
    }
    @if (uiState.anlageGroup) {
      <div>
        @if (tasks && tasks.length > 0) {
          <div>
            <div class="row">
              <div class="col">
                <div class="toolbar-top">
                  <ctrl-btn-accept (click)="OnSave($event)"> </ctrl-btn-accept>
                  <ctrl-btn-cancel (click)="OnReset($event)"></ctrl-btn-cancel>
                </div>
                <mat-accordion>
                  <mat-expansion-panel hideToggle>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        Informationen
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div style="text-align: justify; margin: 10px;">
                      <span i18n='Beschreibung über Aufgaben verschieben@@DragnDrop'>The tasks can be ordered with
                    Drag'n'Drop. Also the tasks can be moved by selecting them (e.g with a mouse click) and the
                    combination of Ctrl + Arrow Key. Tasks that are not order yet will be placed at the bottom of the
                    list. Tasks that are already completed won't appear anymore.</span>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>
            <app-sortable-list [items]="tasks" (listDropped)="OnDragEnd($event)">
              <ng-template let-task>
                <app-planung-task-card [task]="task" [handlesDragDrop]="false" [displayTaskLocation]="true"
                  tooltipPosition="bottom">
                </app-planung-task-card>
              </ng-template>
            </app-sortable-list>
            @if (displayBottomToolbar) {
              <div class="row">
                <div class="col">
                  <hr />
                  <div class="toolbar-bottom">
                    <ctrl-btn-accept (click)="OnSave($event)"> </ctrl-btn-accept>
                    <ctrl-btn-cancel (click)="OnReset($event)"></ctrl-btn-cancel>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        @if (!tasks || tasks.length === 0) {
          <div>
            <span class="info" i18n='Diese Anlagengruppe enthält keine Aufgaben@@NoTaskInFacilityGroup'>This facility group
          does not contain any tasks.</span>
          </div>
        }
      </div>
    }
  </div>
</div>